import MaterialTable from 'material-table';
import Moment from "moment";
import "moment/locale/es";
import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import Swal from 'sweetalert2';
import { updateStateForId } from '../../../helpers/updateState';
import { serviceEliminarNameImpuesto } from '../../../services/nameimpuestos/nameimpuestoService';
import { lenguage, optionsTable, tableIcons, } from "../../structure/config-datatable";
import { MembresiaEditModal } from './edit-model/MembresiaEditModal';





export const DatatableMembresia = () => {

    const dispatch = useDispatch();
    const [modalEditar, setmodalEditar] = useState(false);
    const [edit, setEdit] = useState({})
    const [state, setState] = useState([]);
    const [originalData, setOriginalData] = useState([]);
    const [tiposMembresia, setTiposMembresia] = useState([]);


    //PETICION HTTP USEEFFECT - Cargar membresías
    useEffect(() => {
        async function getData() {
            const url = `${process.env.REACT_APP_MI_VARIABLE_DE_ENTORNO}/api/dashboard/membresia`;
            const resp = await fetch(url,
                {
                    method: "GET",
                    headers: {
                        'Content-type': 'application/json',
                        'x-token': localStorage.getItem('token')
                    },
                }
            );
            const respuesta = await resp.json();

            if (resp.ok) {
                setState(respuesta.membresias);
                setOriginalData(respuesta.membresias);
            } else {
                if (respuesta.msg === undefined) {
                    Swal.fire('Error', respuesta.errors[0].msg, 'error');
                } else {
                    Swal.fire('Error', respuesta.msg, 'error');
                }
            }
        }
        getData();
    }, []);

    //PETICION HTTP USEEFFECT - Cargar tipos de membresía
    useEffect(() => {
        async function getTiposMembresia() {
            try {
                const url = `${process.env.REACT_APP_MI_VARIABLE_DE_ENTORNO}/api/dashboard/tipomembresia`;
                const resp = await fetch(url,
                    {
                        method: "GET",
                        headers: {
                            'Content-type': 'application/json',
                            'x-token': localStorage.getItem('token')
                        },
                    }
                );
                const respuesta = await resp.json();

                if (resp.ok) {
                    setTiposMembresia(respuesta.tiposMembresia);
                } else {
                    console.log('Error al cargar tipos de membresía:', respuesta.msg);
                }
            } catch (error) {
                console.log('Error fetching tipos de membresía:', error);
            }
        }
        getTiposMembresia();
    }, []);


    ;



    //===========CONFIG TABLE ============================================
    const acciones = [{
        icon: () => <tableIcons.Edit style={{ color: "#FFC007" }} />,
        tooltip: 'Editar',
        onClick: (e, rowData) => { setmodalEditar(true); onSearchEntity(state.find(user => user.id === rowData.id)) },

    },
    {
        icon: () => <tableIcons.Delete style={{ color: "#DC3444" }} />,
        tooltip: 'Eliminar',
        onClick: (e, rowData) => onEliminar(state.find(user => user.id === rowData.id))
    }]

    //CREACION DE LAS COLUMNAS QUE SE VAN A MOSTRAR
    const columnas = [
        {
            title: "Codigo",
            field: "Membresia.id"
        },
        {
            title: "Email",
            field: "email",
        },
        {
            title: "Contador",
            field: "Contador.nombrerazonsocial",
        },
        {
            title: "Fecha Vencimiento",
            field: "Membresia.fecha_vencimiento",
            render: rowData =>
                rowData.Membresia.fecha_vencimiento !== undefined ?
                    Moment(rowData.Membresia.fecha_vencimiento).format("D MMM YYYY")
                    : ""
        },
        {
            title: "Tipo Membresia",
            field: "Membresia.tipomembresia.membresia",
        },
    ]
    const data = state;
    ;


    // FUNCTION ==================================
    const onEliminar = async (user) => {
        ;
        const respuesta = await dispatch(serviceEliminarNameImpuesto(user.id));
        ;
        const newArray = updateStateForId(state, respuesta);
        ;
        setState([...newArray]);
    }
    // FIN FUNCTION ==================================
    const onSearchEntity = (entidad) => {
        console.log("EDITAR ENTIDAD DATATABLE", entidad);
        setEdit({
            id: entidad.Membresia.id,
            email: entidad.email,
            fechaVencimiento: entidad.Membresia.fecha_vencimiento,
            idMembresia: entidad.Membresia.tipomembresia.id,
            membresia: entidad.Membresia.tipomembresia.membresia
        })
    }

    const filterByType = (type) => {
        setState(originalData.filter(row =>
            Moment(row.Membresia.fecha_vencimiento).isSame(new Date(), 'month') &&
            row.Membresia.tipomembresia.membresia === type
        ));
    };

    const deleteFilter = () => {
        setState(originalData);
    };

    // Colores para cada tipo de membresía
    const getFilterButtonColor = (index) => {
        const colors = ['success', 'primary', 'warning', 'info', 'danger'];
        return colors[index % colors.length];
    };

    return (
        <>
            <div className="card-body">
                <div>

                    <div style={{
                        display: 'flex',
                        flexWrap: 'wrap',
                        gap: '10px',
                        marginBottom: '20px',
                        alignItems: 'center',
                        padding: '15px',
                        backgroundColor: '#f8f9fa',
                        borderRadius: '6px',
                        border: '1px solid #dee2e6'
                    }}>
                        <span style={{
                            fontWeight: 'bold',
                            marginRight: '10px',
                            color: '#495057'
                        }}>
                            Filtrar por membresía próxima a vencer:
                        </span>
                        {tiposMembresia.map((tipo, index) => (
                            <button
                                key={tipo.id}
                                className={`btn btn-${getFilterButtonColor(index)}`}
                                onClick={() => filterByType(tipo.membresia)}
                                style={{ whiteSpace: 'nowrap' }}
                            >
                                {tipo.membresia}
                            </button>
                        ))}
                        {tiposMembresia.length > 0 && (
                            <button
                                className="btn btn-secondary"
                                onClick={() => deleteFilter()}
                                style={{ marginLeft: 'auto' }}
                            >
                                Limpiar Filtro
                            </button>
                        )}
                    </div>

                    <MaterialTable
                        icons={tableIcons}
                        columns={columnas}
                        data={data}
                        title={""}
                        options={optionsTable}
                        localization={lenguage}
                        actions={acciones}
                    />
                    <MembresiaEditModal 
                        setmodalEditar={setmodalEditar}
                        modalEditar={modalEditar}
                        editar={edit}
                        state={state}
                        setState={setState}
                        tiposMembresia={tiposMembresia}
                    />
                </div>
            </div>
        </>
    )
}



